export default function (context, item) {
    let url = item.ReportFormat == 'html' ? ('/tourclient/editor/#/print/' + item.WebReportId + '?WebReportId=' + item.WebReportId) :  item.Url;
    if (item.fields.length) {
        item.fields.forEach(i => {
            let v = '';
            switch (i.Type) {
                case 'date':
                    if (i.Value) {
                        v = i.Value;
                    }
                    break;
                case 'list':
                case 'list_partner':
                case 'list_reference':
                case 'list_load':
                    if (i.Value) {
                        if (typeof i.Value === 'object') {
                            i.Value.forEach(item => {
                                if (v) v += ',';
                                v += item;
                            })
                        } else {
                            v += i.Value;
                        }
                    }
                    break;
                default:
                    v = i.Value;
            }

            url += v ? '&' + encodeURIComponent('parameters[' + i.FieldName + ']') + '=' + encodeURIComponent(v) : '';
        });
    }
    if (item.NeedSelectedData && item.NeedSelectedData.length) {
        let a = '';
        item.NeedSelectedData.forEach(i => {
            context.getters.selections.forEach(j => {
                if (a) a += ',';
                a += j[i];
            });
            a = '&' + encodeURIComponent('parameters[' + i + ']') + '=' + encodeURIComponent(a);

        });
        url += a;
    }
    if (item.ReportFormat == 'html'){
        url = url.replace(/parameters\[/g, '').replace(/\]/g, '');
    }
    window.open(url);
}